import { gql } from '@apollo/client';

export const GET_HANDOVER_CARRIERS_BY_WAREHOUSE_ID = gql`
    query GetHandoverCarriersByWarehouseId($warehouseId: Long!, $includeCarrierId: Long) {
        getHandoverCarriersByWarehouseId(warehouseId: $warehouseId, includeCarrierId: $includeCarrierId) {
            id
            carrierCode
            carrierName
            shortCarrierName
            carrierType
            contactName
            contactPhone
            centerWarehouseIds
            status
        }
    }
`;

export interface HandoverCarrierType {
    id: string;
    carrierCode: number;
    carrierName: string;
    shortCarrierName: string | null;
    carrierType: number;
    contactName: string | null;
    contactPhone: string | null;
    centerWarehouseIds: string[];
    status: number;
}

export interface GetHandoverCarriersByWarehouseIdResponse {
    getHandoverCarriersByWarehouseId: HandoverCarrierType[];
}
